import { EmcStatusDto } from '../dto'
import { EmcStatusModel } from '../../models'
import { differenceInSeconds } from 'date-fns'
import { normalizeKeyToCamelCase, formatIpAddress } from '../../utils/emc-status-utils'

const VALID_ONLINE_TIME_DIFF_IN_SECONDS = 60

const toIsOnline = (timestamp?: string): boolean => {
  if (!timestamp) {
    return false
  }

  const lastTimestamp = new Date(timestamp)

  if (Number.isNaN(lastTimestamp.getTime())) {
    return false
  }

  return differenceInSeconds(new Date(), lastTimestamp) <= VALID_ONLINE_TIME_DIFF_IN_SECONDS
}

const fromEmcStatusDtoToModelTransformer = (dto: EmcStatusDto): EmcStatusModel => {
  const normalized = Object.entries(dto).reduce<Record<string, unknown>>((acc, [key, value]) => {
    acc[normalizeKeyToCamelCase(key)] = value
    return acc
  }, {})

  const ipAddress = formatIpAddress(dto.IP)

  return {
    ...normalized,
    ipAddress,
    isOnline: toIsOnline(dto.time),
  }
}

export default fromEmcStatusDtoToModelTransformer
